/**
 * Asynchronously loads the component
 */
import Loadable from 'react-loadable';

import PDPContentSkeleton from 'app/shared/components/skeletons/PDPContentSkeleton';


export default Loadable({
    loader: () => import('./index'),
    loading: PDPContentSkeleton,
});
